/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

export const SNACKBAR_SUCCESS = "SNACKBAR_SUCCESS";
export const SNACKBAR_ERROR = "SNACKBAR_ERROR";
export const SNACKBAR_INFO = "SNACKBAR_INFO";
export const SNACKBAR_CLEAR = "SNACKBAR_CLEAR";
export const SET_VALIDATION_STATE = "SET_VALIDATION_STATE";

export const setValidationState = (isActive) => ({
  type: SET_VALIDATION_STATE,
  payload: isActive,
});

export const clearSnackbar = () => ({
  type: SNACKBAR_CLEAR,
});

export const showSuccessSnackbar = (message) => ({
  type: SNACKBAR_SUCCESS,
  payload: message,
});

export const showErrorSnackbar = (message) => ({
  type: SNACKBAR_ERROR,
  payload: message,
});

export const showInfoSnackbar = (message) => ({
  type: SNACKBAR_INFO,
  payload: message,
});
